import React from "react";

import CommandesTabContent from "./CommandesTabContent";
import CommandesCreditsTabContent from "./CommandesCreditsTabContent";
import ApprovTabContent from "./Approvisionnement/ApprovTabContent";
import AdvancedStock from "./AdvancedStock/AdvancedStock";
import MainFacturesView from "../../Views/MainFacturesView";

function CommandesViewTabsContent({ activeTab }) {
  switch (activeTab) {
    case "Orders":
      return <CommandesTabContent activeTab={activeTab} />;
    case "Invoices":
      return <MainFacturesView activeTab={activeTab} />;
    case "Credits":
      return <CommandesCreditsTabContent activeTab={activeTab} />;
    // case "Supplies":
    //   return <ApprovTabContent activeTab={activeTab} />;
    // case "Stock":
    //   return <AdvancedStock />;
    default:
      return <CommandesTabContent />;
  }
}

export default CommandesViewTabsContent;
